import React from 'react';
import PropTypes from 'prop-types';

const Avatar = ({ src, size = 24 }) => (
  <img style={{ width: size, height: size }} src={src} alt="" className="ws-difm-avatar" />
);

Avatar.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default Avatar;
